import { EndorsementServiceType } from "../services/endorsement-service";
import Endorsement from "../models/endorsement";

export class ListEndorsementsInteractor {
  endorsementService: EndorsementServiceType;

  constructor(endorsementService: EndorsementServiceType) {
    this.endorsementService = endorsementService;
  }

  async listEndorsements(): Promise<Endorsement[]> {
    return this.endorsementService.listEndorsements();
  }
}
